/**
 * Lightweight prompt section base for runtime-hosted agents.
 * Runtime defaults to code fallbacks and simple {{variable}} interpolation.
 */
export class PromptSectionBase {
    getContent() {
        return this.fallbackContent;
    }
    getContentWithVariables(variables) {
        return this.fallbackContent.replace(/\{\{([^}]+)\}\}/g, (_m, key) => {
            const value = variables[key.trim()];
            return value ?? "";
        });
    }
    getKeywordsKey() {
        return this.keywordsKey;
    }
    getFallbackContent() {
        return this.fallbackContent;
    }
}
export default PromptSectionBase;
